module.exports = __webpack_public_path__ + "img/push_ups.223092a0.jpg";